export class StateLicensureDetails {
    compact: boolean;
    nursys: boolean;
    tempLicenses: boolean;
    paperless: number;
    paperlessNotes: string;
    projectTypeId: number;
    projectNotes: string;
    initialTime: string;
    initialTimeCategory: number;
    initialTimeType: number;
    initialCost: number;
    initialCostBreakdown: string;
    initialNotes: string;
    renewalTime: string;
    renewalTimeType: number;
    renewalCost: number;
    renewalNotes: string;
    renewalBreakdown: string;
    additionalInfo: string;
    adminNotes: string;
    complianceOwnerId: number;
    id: number;
    stateId?: number;
    state: string;
    paperlessText: string;
    initialTimeText: string;
    renewalTimeText: string;
    initialTimeCategoryText: string;
    stateName: string;
    initialTimeDescription: string;
    isWalkthrough: boolean;
    isQuick: boolean;
    complianceOwnerName: string;
    projectTypeName: string;
    licensureProject: string;
    stateExecutiveOrderExpirationDate: Date;
}
